module.exports = __webpack_public_path__ + "static/img/gogo-logo.561cbe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/gogo-logo.svg
// module id = 1102
// module chunks = 1